const triggers = document.querySelectorAll('[data-js="bills-modal-open"]');

if (triggers.length) {
  const modalEl = document.getElementById('boletoModal');
  const iframe = document.getElementById('boletoIframe');

  if (modalEl && iframe) {
    const blankSrc = 'about:blank';

    function getNexxeraConfig() {
      const config = window.NEXXERA_CONFIG;
      if (!config?.url || !config?.api_hash || !config?.fame_api_url) {
        return null;
      }
      const { hashGrupo, inscCedente } = config.params || {};
      if (!hashGrupo || !inscCedente) {
        return null;
      }
      return config;
    }

    function buildNexxeraUrl(config, doc, chave) {
      const url = new URL(config.url);
      url.searchParams.set('hashGrupo', config.params.hashGrupo);
      url.searchParams.set('inscCedente', config.params.inscCedente);
      url.searchParams.set('inscSacado', doc);
      url.searchParams.set('chave', chave);
      return url.toString();
    }

    function fetchMakeToken(config, doc) {
      const tokenUrl = `${config.fame_api_url}/bills/make-token/${encodeURIComponent(config.api_hash)}/${encodeURIComponent(doc)}`;
      return $.ajax({
        url: tokenUrl,
        type: 'GET',
        dataType: 'json',
        crossDomain: true,
      });
    }

    modalEl.addEventListener('show.bs.modal', function (event) {
      const trigger = event.relatedTarget;
      if (!trigger || trigger.dataset.js !== 'bills-modal-open') {
        return;
      }

      const doc = (trigger.dataset.jsDoc || '').replace(/\D/g, '');
      if (doc.length !== 14) {
        Swal.fire({
          title: 'CNPJ inválido',
          text: 'Não foi possível identificar o documento do sacado.',
          icon: 'error',
          confirmButtonText: 'Fechar',
        });
        event.preventDefault();
        return;
      }

      const config = getNexxeraConfig();
      if (!config) {
        Swal.fire({
          title: 'Configuração incompleta',
          text: 'As configurações da Nexxera não estão disponíveis nesta página.',
          icon: 'error',
          confirmButtonText: 'Fechar',
        });
        event.preventDefault();
        return;
      }

      iframe.src = blankSrc;

      fetchMakeToken(config, doc)
        .done(function (response) {
          const chave = response?.token;
          if (!chave) {
            Swal.fire({
              title: 'Erro ao gerar chave',
              text: 'A API não retornou um token válido.',
              icon: 'error',
              confirmButtonText: 'Fechar',
            });
            return;
          }
          iframe.src = buildNexxeraUrl(config, doc, chave);
        })
        .fail(function (xhr) {
          let message = 'Não foi possível obter a chave de acesso ao boleto.';
          if (xhr.responseJSON?.message) {
            message = xhr.responseJSON.message;
          }
          Swal.fire({
            title: 'Erro ao gerar chave',
            text: message,
            icon: 'error',
            confirmButtonText: 'Fechar',
          });
        });
    });

    modalEl.addEventListener('hidden.bs.modal', function () {
      iframe.src = blankSrc;
    });
  }
}
